import React from 'react';
import CustomTable from '../../../blueplanitUtils/CustomTabels';
import { useSelector } from 'react-redux';
export const EditClientHistory = () => {
    const clientData = useSelector(state => state.clients.clientData);
    const clientFields = ["Updated By", "Position", "Edit Status", "Updated Date"]
    const DataLabel = ["id", "action", "EditStatus", "changeTime"]
    const DateField = {
        changeTime: true
    }
    return (
        <>
            <CustomTable
                title="Client Edit History"
                data={clientData?.EditClient || []}
                dataLabel={DataLabel}
                columns={clientFields}
                Id="client_info"
                showEdit={false}
                dateFieldsMap={DateField}
            />
        </>
    )
}